"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiClient = void 0;
const environment_1 = require("./endpoints/featureExp/environment");
const flag_1 = require("./endpoints/featureExp/flag");
const flagCodeUsage_1 = require("./endpoints/featureExp/flagCodeUsage");
const flagUsage_1 = require("./endpoints/featureExp/flagUsage");
const project_1 = require("./endpoints/featureExp/project");
const campaign_1 = require("./endpoints/featureExp/campaign");
const variationGroup_1 = require("./endpoints/featureExp/variationGroup");
const variation_1 = require("./endpoints/featureExp/variation");
const flagVariation_1 = require("./endpoints/featureExp/flagVariation");
const goals_1 = require("./endpoints/featureExp/goals");
const key_1 = require("./endpoints/featureExp/key");
const audiences_1 = require("./endpoints/audiences");
const settings_1 = require("./endpoints/settings");
const oauth_1 = require("./endpoints/oauth");
const experiment_1 = require("./endpoints/experiment");
const dmpSegments_1 = require("./endpoints/dmpSegments");
const configurations_1 = require("./endpoints/configurations");
const apiCall_1 = require("./helpers/apiCall");
const token_1 = require("./helpers/token");
const modifications_1 = require("./endpoints/modifications");
const overlap_1 = require("./endpoints/overlap");
const priorities_1 = require("./endpoints/priorities");
const variations_1 = require("./endpoints/variations");
const geolocalisation_1 = require("./endpoints/geolocalisation");
const apiCallDcInfos_1 = require("./helpers/apiCallDcInfos");
const dcInfos_1 = require("./endpoints/dcInfos");
const reporting_1 = require("./endpoints/reporting");
const thirdParty_1 = require("./endpoints/thirdParty");
const users_1 = require("./endpoints/users");
const reportingSetup_1 = require("./endpoints/reportingSetup");
const reportingRealtime_1 = require("./endpoints/reportingRealtime");
const widgets_1 = require("./endpoints/widgets");
const exporter_1 = require("./endpoints/exporter");
const targetings_1 = require("./endpoints/targetings");
const ciKeywords_1 = require("./endpoints/ciKeywords");
const folder_1 = require("./endpoints/folder");
const exclusionGroups_1 = require("./endpoints/exclusionGroups");
const dataExplorer_1 = require("./endpoints/dataExplorer");
const parameters_1 = require("./endpoints/parameters");
const customToolLinks_1 = require("./endpoints/customToolLinks");
const moneyBack_1 = require("./endpoints/moneyBack");
const accounts_1 = require("./endpoints/accounts");
const adminOnboardings_1 = require("./endpoints/adminOnboardings");
const metrics_1 = require("./endpoints/metrics");
const favoriteUrls_1 = require("./endpoints/favoriteUrls");
const additionalInformation_1 = require("./endpoints/additionalInformation");
const components_1 = require("./endpoints/components");
const providers_1 = require("./endpoints/providers");
const notes_1 = require("./endpoints/notes");
const reportingFilterPresets_1 = require("./endpoints/reportingFilterPresets");
const receivers_1 = require("./endpoints/accounts/receivers");
const selectorDom_1 = require("./endpoints/selectorDom");
const templates_1 = require("./endpoints/templates");
const dashboardFilters_1 = require("./endpoints/dashboardFilters");
const productHits_1 = require("./endpoints/productHits");
const api_1 = require("./endpoints/widget-themes/api");
const plugins_1 = require("./endpoints/plugins");
const organizations_1 = require("./endpoints/organizations");
const backend_1 = require("./endpoints/backend");
const globalCodes_1 = require("./endpoints/globalCodes");
const compilationHistory_1 = require("./endpoints/compilationHistory");
const widget_presets_1 = require("./endpoints/widget-presets");
const uvCounter_1 = require("./endpoints/uvCounter");
const api_2 = require("./endpoints/integrationDatabases/api");
const transactions_affiliations_1 = require("./endpoints/transactions-affiliations");
const defaultHosts_1 = require("./defaultHosts");
const aiGateway_1 = require("./endpoints/aiGateway");
const mappings_1 = require("./endpoints/mappings");
const mde_1 = require("./endpoints/mde");
const reportViews_1 = require("./endpoints/reportViews");
const api_3 = require("./endpoints/integration/api");
const alerts_1 = require("./endpoints/alerts");
const eai_saved_requests_1 = require("./endpoints/accounts/eai-saved-requests");
const apiClient = (options = {}) => {
    const { errorHandlers = {}, moneyBackEnvHeader } = options;
    const overwrites = { ...(options.hosts || {}) };
    Object.keys(overwrites).forEach((k) => {
        if (!overwrites[k])
            delete overwrites[k];
    });
    const resolvedHosts = { ...defaultHosts_1.defaultHosts, ...overwrites };
    const token = (0, token_1.tokenHandler)(options.token);
    const caller = (0, apiCall_1.apiCall)({ host: resolvedHosts.default, token, apiErrorHandler: errorHandlers.default });
    const geolocalisationCaller = (0, apiCall_1.apiCall)({
        host: resolvedHosts.default,
        apiErrorHandler: errorHandlers.default,
    });
    const callerDataExplorer = (0, apiCall_1.apiCall)({
        host: resolvedHosts.dataExplorer,
        token,
        options: {
            arrayFormat: 'brackets',
        },
        apiErrorHandler: errorHandlers.dataExplorer,
    });
    const callerDataExplorerV2 = (0, apiCall_1.apiCall)({
        host: resolvedHosts.dataExplorer,
        token,
        options: {
            arrayFormat: 'brackets',
        },
        apiErrorHandler: errorHandlers.dataExplorer,
    });
    const callerRealtime = (0, apiCall_1.apiCall)({
        host: resolvedHosts.realtime,
        token,
        apiErrorHandler: errorHandlers.realtime,
    });
    const callerCodeModifications = (0, apiCall_1.apiCall)({
        host: resolvedHosts.default,
        token,
        apiErrorHandler: errorHandlers.default,
    });
    const makeUrl = (0, apiCall_1.makeUrlFactory)(resolvedHosts.default || '');
    const makeUrlWithVersion = (version, ...args) => (0, apiCall_1.makeUrlFactory)(resolvedHosts.default || '', version)(...args);
    const makeUrlWithHost = (host) => (0, apiCall_1.makeUrlFactory)(host);
    const dcInfosCaller = (0, apiCallDcInfos_1.apiCallDcInfos)();
    const exporterCaller = (0, apiCall_1.apiCall)({
        host: resolvedHosts.exporter,
        token,
        apiErrorHandler: errorHandlers.exporter,
    });
    const reportingCaller = (0, apiCall_1.apiCall)({
        host: resolvedHosts.reporting,
        token,
        apiErrorHandler: errorHandlers.reporting,
        fetchOptions: {
            referrerPolicy: 'no-referrer-when-downgrade',
        },
    });
    const uvCounterCaller = (0, apiCall_1.apiCall)({
        host: resolvedHosts.uvCounter,
        token,
        apiErrorHandler: errorHandlers.uvCounter,
        options: {
            arrayFormat: 'comma',
        },
    });
    const callerApiV1 = (0, apiCall_1.apiCall)({
        host: resolvedHosts.default,
        token,
        version: 'v1',
        options: { arrayFormat: 'comma' },
        apiErrorHandler: errorHandlers.default,
    });
    const callerBackend = (0, apiCall_1.apiCall)({
        host: resolvedHosts.default,
        token,
        options: { arrayFormat: 'comma' },
        apiErrorHandler: errorHandlers.default,
    });
    const moneyBackHeaders = moneyBackEnvHeader ? { 'X-ABTastyEnv': moneyBackEnvHeader } : undefined;
    const moneyBackCaller = (0, apiCall_1.apiCall)({
        host: resolvedHosts.moneyBack,
        token,
        headers: moneyBackHeaders,
        apiErrorHandler: errorHandlers.moneyBack,
    });
    const integrationDatabaseCaller = (0, apiCall_1.apiCall)({
        host: resolvedHosts.integrationDatabase,
        token,
        version: 'v1',
        apiErrorHandler: errorHandlers.integrationDatabase,
    });
    const flagshipCaller = (0, apiCall_1.apiCall)({
        host: resolvedHosts.flagship,
        options: { arrayFormat: 'brackets' },
        token,
        fetchOptions: {
            referrerPolicy: 'no-referrer-when-downgrade',
        },
        apiErrorHandler: errorHandlers.flagship,
    });
    const aiGatewayCaller = ({ projectName }) => (0, apiCall_1.apiCall)({
        host: resolvedHosts.aiGateway,
        token,
        headers: { 'x-source': projectName },
        apiErrorHandler: errorHandlers.default,
    });
    const integrationCaller = (0, apiCall_1.apiCall)({
        host: resolvedHosts.integration,
        token,
        apiErrorHandler: errorHandlers.default,
    });
    return {
        helpers: {
            token,
            hosts: resolvedHosts,
            caller,
            makeUrl,
            makeUrlWithHost,
            makeUrlWithVersion,
            followLocation: (0, apiCall_1.generateFollowLocation)(token, resolvedHosts.default),
        },
        v1: {
            audiences: (0, audiences_1.audiencesV1)(callerApiV1),
            targetings: (0, targetings_1.targetingsV1)(callerApiV1),
            experiment: (0, experiment_1.experimentV1)(callerApiV1),
            accounts: (0, accounts_1.accountApiV1)(callerApiV1),
            adminOnboardings: (0, adminOnboardings_1.adminOnboardingsApiV1)(callerApiV1),
            metrics: (0, metrics_1.metricsApi)(callerApiV1),
            reportViews: (0, reportViews_1.reportViewsApi)(callerApiV1),
            favoriteUrls: (0, favoriteUrls_1.favoriteUrls)(callerApiV1),
            accountProviders: (0, providers_1.accountProviders)(callerApiV1),
            notes: (0, notes_1.notesApi)(callerApiV1),
            users: (0, users_1.usersV1)(callerApiV1),
            folder: (0, folder_1.folder)(callerApiV1),
            exclusionGroups: (0, exclusionGroups_1.exclusionGroupsApi)(callerApiV1),
            reportingFilterPresets: (0, reportingFilterPresets_1.reportingFilterPresets)(callerApiV1),
            accountReceivers: (0, receivers_1.accountReceivers)(callerApiV1),
            eaiSavedRequests: (0, eai_saved_requests_1.eaiSavedRequests)(callerApiV1),
            component: (0, components_1.component)(callerApiV1),
            templates: (0, templates_1.templatesV1)(callerApiV1),
            dashboardFilters: (0, dashboardFilters_1.dashboardFiltersApi)(callerApiV1),
            accountPlugins: (0, plugins_1.accountPluginsApiV1)(callerApiV1),
            widgetThemes: (0, api_1.accountWidgetThemesApiV1)(callerApiV1),
            widgetPresets: (0, widget_presets_1.accountWidgetPresetsApi)(callerApiV1),
            organizations: (0, organizations_1.organizations)(callerApiV1),
            globalCodes: (0, globalCodes_1.globalCodes)(callerApiV1),
            compilationHistory: (0, compilationHistory_1.compilationHistoryApi)(callerApiV1),
            modifications: (0, modifications_1.modificationsV1)(callerApiV1),
            codeModifications: (0, modifications_1.codeModificationsV1)(callerCodeModifications),
            configurations: (0, configurations_1.configurations)(callerApiV1),
            transactionAffiliations: (0, transactions_affiliations_1.transactionAffiliationsApi)(callerApiV1),
            alerts: (0, alerts_1.alerts)(callerApiV1),
            aiGateway: (options) => (0, aiGateway_1.aiGatewayV1Api)(aiGatewayCaller(options)),
            /**
             * Access external AI service providers via the ABTasty AI gateway
             * @param options Please provide a name of your project for cost tracking purposes
             *
             * More information: https://abtasty.atlassian.net/wiki/spaces/ATK/pages/749273100/AI+API+Gateway#Additional-mandatory-parameter
             */
            mappings: (0, mappings_1.mappings)(callerApiV1),
            variations: (0, variations_1.variationsV1)(callerApiV1),
        },
        integrationDatabases: (0, api_2.integrationDatabasesApi)(integrationDatabaseCaller),
        accounts: (0, accounts_1.accountApi)(caller),
        audience: (0, audiences_1.audience)(caller),
        settings: (0, settings_1.settings)(caller),
        experiment: (0, experiment_1.experiment)(caller),
        variations: (0, variations_1.variations)(caller),
        dmpSegments: (0, dmpSegments_1.dmpSegments)(caller),
        geolocalisation: (0, geolocalisation_1.geolocalisation)(geolocalisationCaller),
        dcInfos: (0, dcInfos_1.dcInfos)(dcInfosCaller),
        reportingSetup: (0, reportingSetup_1.reportingSetup)(caller, callerDataExplorer),
        reporting: (0, reporting_1.reporting)(reportingCaller),
        uvCounter: (0, uvCounter_1.uvCounterApi)(uvCounterCaller),
        thirdParty: (0, thirdParty_1.thirdParty)(caller),
        goals: (0, configurations_1.goals)(caller),
        modifications: (0, modifications_1.modifications)(caller),
        oauth: (0, oauth_1.oauth)(caller),
        realtime: (0, reportingRealtime_1.realtime)(callerRealtime),
        widget: (0, widgets_1.widget)(caller),
        widgetQueryForm: (0, widgets_1.widgetQueryForm)(caller, callerDataExplorer),
        exporter: (0, exporter_1.exporter)(exporterCaller),
        ciKeywords: (0, ciKeywords_1.ciKeywordsApi)(caller),
        dataExplorer: (0, dataExplorer_1.dataExplorer)(callerDataExplorer),
        dataExplorerV2: (0, dataExplorer_1.dataExplorerV2)(callerDataExplorerV2),
        parameters: (0, parameters_1.parameters)(caller),
        customToolLinks: (0, customToolLinks_1.customToolLinks)(caller),
        mde: (0, mde_1.mde)(caller),
        moneyBack: (0, moneyBack_1.moneyBack)(moneyBackCaller),
        additionalInformation: (0, additionalInformation_1.additionalInformation)(caller),
        overlap: (0, overlap_1.overlap)(caller),
        priorities: (0, priorities_1.priorities)(caller),
        componentBackend: (0, components_1.componentBackend)(caller),
        providers: (0, targetings_1.providers)(caller),
        selectorDom: (0, selectorDom_1.selectorDom)(caller),
        productHits: (0, productHits_1.productHitsApi)(caller),
        backend: (0, backend_1.backendApi)(callerBackend),
        featureExp: {
            key: (0, key_1.featureExpKey)(flagshipCaller),
            flag: (0, flag_1.featureExpFlag)(flagshipCaller),
            project: (0, project_1.featureExpProject)(flagshipCaller),
            environment: (0, environment_1.featureExpEnvironment)(flagshipCaller),
            codeUsage: (0, flagCodeUsage_1.featureExpCodeUsage)(flagshipCaller),
            flagUSage: (0, flagUsage_1.featureExpFlagUsage)(flagshipCaller),
            campaign: (0, campaign_1.featureExpCampaign)(flagshipCaller),
            flagVariation: (0, flagVariation_1.featureExpFlagVariation)(flagshipCaller),
            variation: (0, variation_1.featureExpVariation)(flagshipCaller),
            variationGroup: (0, variationGroup_1.featureExpVariationGroup)(flagshipCaller),
            goals: (0, goals_1.featureExpGoals)(flagshipCaller),
        },
        integration: (0, api_3.integrationApi)(integrationCaller),
    };
};
exports.apiClient = apiClient;
//# sourceMappingURL=apiClient.js.map